export const preOrderHelpText = 'Waiting for an admin to approve this service';
export const findingTechHelpText = 'Scheduling a technician who can accommodate your time';
export const findingPreferredTechHelpText = 'Scheduling with your preferred technician';
export const processingHelpText = 'Processing your content';
export const adminHoldHelpText = 'This service is being worked on';
export const liveNoListingText = 'This service is complete';
